<template>
  <span :class="`icon icon-${name}`" @click="$emit('click')"/>
</template>

<script>
export default {
  props: {
    name: String,
  },
};
</script>

<style src="./index.css"/>
